export var ellipsizeText = function (text, maxLength) {
    return text.length > maxLength
        ? "".concat(text.slice(0, maxLength).trim(), "...")
        : text;
};
